import { CopyPortalLicenseClientEventsResponse } from "../../../../../../../generated/data-contracts";
import { useContext } from "react";
import { AvisContext } from "../../../../../../shared/context/AvisContext";
import { AvisLoader } from "../../../../../../shared/components";

interface ICopyProgramReportResultFormProps {
  copyResult: CopyPortalLicenseClientEventsResponse | undefined;
}
export function CopyProgramReportResultForm(
  props: Readonly<ICopyProgramReportResultFormProps>,
) {
  const { copyResult } = props;
  const { res } = useContext(AvisContext);

  let displayDialogText = "";
  if (copyResult)
    displayDialogText = copyResult.hasDataFileCopyError
      ? res(
          "licensees_CopyProgramReport_ProgressDialog_label_CompletedWithFileError",
        )
      : res("licensees_CopyProgramReport_ProgressDialog_label_Completed");
  return (
    <div>
      {!copyResult && <AvisLoader inline />}
      <div>
        {copyResult
          ? displayDialogText
          : res("licensees_CopyProgramReport_ProgressDialog_label_InProgress")}
      </div>
    </div>
  );
}
